"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unescape = exports.escape = void 0;
const TILDE_RE = /~/g;
const SLASH_RE = /\//g;
const TILDE_0_RE = /~0/g;
const TILDE_1_RE = /~1/g;
function escape(frag) {
    return frag.replace(TILDE_RE, '~0').replace(SLASH_RE, '~1');
}
exports.escape = escape;
function unescape(frag) {
    return frag.replace(TILDE_1_RE, '/').replace(TILDE_0_RE, '~');
}
exports.unescape = unescape;
//# sourceMappingURL=utils.js.map